import { stringifyQueryFilters } from '@app/src/hooks/queryState'
import { Operators } from '@app/src/pages/ResourceCollection/Filters/useFilters'
import paths from '@app/src/wf-constants/paths'
import { generatePath } from 'react-router-dom'

export type AssessmentLinkResolver = (assessmentTemplateId: number, periodName?: string) => string | undefined

export const providerAssessmentLinkResolver =
  (providerId: number): AssessmentLinkResolver =>
  (assessmentTemplateId, periodName) => {
    if (periodName === undefined) return undefined
    return stringifyQueryFilters({
      url: generatePath(paths.providerBaselineAssessmentWithId, { supplierId: providerId }),
      queryParams: {
        filters: [
          { name: 'assessmentTemplate.id', value: assessmentTemplateId, operator: Operators.EqualTo },
          { name: 'periodName', value: periodName, operator: Operators.EqualTo },
        ],
      },
    })
  }
